// extracted by mini-css-extract-plugin
export default {"main-header":"MainHeader_main-header__Jy334","message_button":"MainHeader_message_button__jWoKX","logoContainer":"MainHeader_logoContainer__4Ck8n","logo":"MainHeader_logo__D72mJ"};